import joi from 'joi';

import type { GraphPath } from '../GraphPath';
import {
  type DeviceGroupAttribute,
  deviceGroupAttributes,
} from '../graphSettings/attributes';
import {
  type GraphTechnologies,
  graphTechnologiesSchema,
} from '../graphTechnologies';
import {
  type GraphLayoutRequest,
  graphLayoutRequestForbidRecalculateSchema,
  graphLayoutRequestSchema,
} from './GraphLayoutRequest';

export interface GraphTopologyParameters {
  groupBy: DeviceGroupAttribute;
  layouts?: GraphLayoutRequest[];
  paths: GraphPath[];
  // field introduced because of cache. If positions are not sent then layout calculation isn't executed - positions are taken from a cache.
  // Set flag to true to execute layout calculation and update result in cache. If `positions` will be sent then it is used only for box placements
  recalculateLayout?: boolean;
  technologies?: GraphTechnologies;
  type: 'topology';
}

export const graphTopologyParametersSchema = joi.object().keys({
  groupBy: joi
    .string()
    .valid(...deviceGroupAttributes)
    .required(),
  layouts: joi.array().items(graphLayoutRequestSchema).unique(),
  paths: joi.array().items(joi.string()).unique().required(),
  recalculateLayout: joi.boolean().when('layouts', {
    is: joi.array().items(graphLayoutRequestForbidRecalculateSchema).required(),
    then: joi.invalid(true),
  }),
  technologies: graphTechnologiesSchema.optional(),
  type: joi.string().valid('topology').required(),
});
